export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StaffCard.vue?vue&type=template&id=6a87ee98&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Divisions/StaffCard.vue?vue&type=template&id=6a87ee98&scoped=true
// module id = 2544
// module chunks = 31